import type { IOrgRepository, OrgCreateInput } from '../repositories/IOrgRepository.js';
import type { OrgEntity } from '../entities/OrgEntity.js';

interface Dependencies {
  orgRepository: IOrgRepository;
}

export function createCreateOrgUseCase({ orgRepository }: Dependencies) {
  return async function createOrg(input: OrgCreateInput): Promise<OrgEntity> {
    return orgRepository.create(input);
  };
}
